import {
  AgentConfigStep,
  AgentConfigStepAgent,
  AgentConfigStepApiAction,
  AgentConfigStepLabelEnum,
  AgentConfigStepLLMAction,
  AgentConfigStepRouteOutputTypeEnum,
  AgentConfigStepTypeEnum,
  AgentConfigStepVectorDBAction
} from '@/types/agent';


export const createStep = {
  [ AgentConfigStepTypeEnum.API ]: ( nextStepNo: number ): AgentConfigStep<AgentConfigStepApiAction> => ( {
    action: { body: 'body', url: 'http://url', method: 'post', headers: [] },
    description: 'a new api step',
    id: `${ AgentConfigStepTypeEnum.API }_step_${ nextStepNo }`,
    inputs: { conversation: { type: 'list' } },
    routes: {
      default: {
        outputs: {
          response: {
            type: AgentConfigStepRouteOutputTypeEnum.FROM_ACTION,
            key: 'response'
          }
        },
        step: AgentConfigStepLabelEnum.END
      }
    },
    type: AgentConfigStepTypeEnum.API
  } ),

  [ AgentConfigStepTypeEnum.AGENT ]: ( nextStepNo: number ): AgentConfigStep<AgentConfigStepAgent> => ( {
    action: {
      context_values: '[]',
      messages_key: 'conversation',
      conversation_key: 'conversation',
      include_full_message: undefined // explicit undefined for ui state differentiation
    },
    description: 'a new Agent step',
    id: `${ AgentConfigStepTypeEnum.AGENT }_step_${ nextStepNo }`,
    inputs: { conversation: { type: 'list' } },
    routes: {
      default: {
        outputs: {
          response: {
            type: AgentConfigStepRouteOutputTypeEnum.FROM_ACTION,
            key: 'response'
          }
        },
        step: AgentConfigStepLabelEnum.END
      }
    },
    type: AgentConfigStepTypeEnum.AGENT
  } ),

  [ AgentConfigStepTypeEnum.LLM ]: ( nextStepNo: number ): AgentConfigStep<AgentConfigStepLLMAction> => ( {
    action: {
      conversation_key: 'conversation',
      model: '',
      prompt: 'your prompt here',
      temperature: 0.5
    },
    description: 'a new LLM step',
    id: `${ AgentConfigStepTypeEnum.LLM }_step_${ nextStepNo }`,
    inputs: { conversation: { type: 'list' } },
    routes: {
      default: {
        outputs: {
          response: {
            type: AgentConfigStepRouteOutputTypeEnum.FROM_ACTION,
            key: 'response'
          }
        },
        step: AgentConfigStepLabelEnum.END
      }
    },
    type: AgentConfigStepTypeEnum.LLM
  } ),

  [ AgentConfigStepTypeEnum.VECTORDB ]: ( nextStepNo: number ): AgentConfigStep<AgentConfigStepVectorDBAction> => ( {
    action: { index: 'my_index', query: 'body' },
    description: 'a new vectordb step',
    id: `${ AgentConfigStepTypeEnum.VECTORDB }_step_${ nextStepNo }`,
    inputs: { conversation: { type: 'list' } },
    routes: {
      default: {
        outputs: {
          response: {
            type: AgentConfigStepRouteOutputTypeEnum.FROM_ACTION,
            key: 'response'
          }
        },
        step: AgentConfigStepLabelEnum.END
      }
    },
    type: AgentConfigStepTypeEnum.VECTORDB
  } )
};
